<template>
  <div id="chatpop">
    <header style="z-index:188">
      <span class="active" v-if="chatBox == 'chatBox'" >聊天</span>
      <span v-else @click="chageMode('chatBox')">聊天</span>
      <span class="active" v-if="chatBox == 'webSite'">公告</span>
      <span v-else @click="chageMode('webSite')">公告</span>
    </header>
    <div class="changeMode">
      <chatBox v-if="chatBox == 'chatBox'"></chatBox>
      <webSite v-if="chatBox == 'webSite'" :currentIndex='currentIndex' :fromWhere="fromWhere" :con="con" :time="time"></webSite>
    </div>
    <hint style="z-index:188"></hint>
  </div>
</template>
<script>
import chatBox from "./chatBox";
import bus from "@/tool/bus";
import hint from "@/components/component/hint";
import webSite from "./webSite";
export default {
  data() {
    return {
      chatBox: "chatBox",
      currentIndex:0,
      fromWhere:'',
      con:'',
      time:''
    };
  },
  mounted() {
    this.isLoginFun();
    bus.$on('noticListDetail',this.changeNotic)
  },
  methods: {
    isLoginFun() {
      this.axios({
        method: "post",
        url: this.url + "api/user/isLogin",
        data: {
          token: window.localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code != 0 || res.data.data.status == 2) {
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("uid");
        }
      });
    },
    chageMode(val){
      this.chatBox = val
    },
    changeNotic(i,value,con,time){
      this.chatBox='webSite'
      this.currentIndex=i
      // console.log('this.currentIndex',this.currentIndex);
      this.fromWhere= value
      this.con=con
      this.time=time
    }
  },
  components: {
    chatBox,
    hint,
    webSite
  }
};
</script>
<style scoped>
#chatpop {
  height: 51.625rem;
  margin-bottom: 2rem;
  background: rgba(242, 242, 242, 1);
  box-shadow: 1px 4px 5px 4px rgba(233, 233, 233, 1);
}
header {
  height: 3.625rem;
  background: linear-gradient(
    0deg,
    rgba(222, 222, 222, 1),
    rgba(243, 243, 243, 1)
  );
  border: 0.0625rem solid rgba(210, 210, 210, 1);
  text-align: left;
  line-height: 3.625rem;
     z-index: 188;
  position: relative;
}
header span {
  margin-left: 1.5rem /* 24/16 */;
  color: #818181;
  font-size: 1rem;
  cursor: pointer;
}
header span.active {
  color: #2a2a2a;
  font-size: 400;
  font-size: 1.25rem;
  border-bottom: 0.125rem solid #2a2a2a;
  padding-bottom: 0.3rem;
  cursor: unset;
}
.changeMode {
  width: 100%;
  height: calc(100% - 3.625rem);
}
</style>


// WEBPACK FOOTER //
// src/components/chatPlaza/chatpop.vue